// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3aQkM","footer":"ModalError_footer__1irOK"};